import { useThemeContext } from '#contexts/ThemeContext';
import { Box, Grid, Typography } from '@material-ui/core';

export interface QuestionDrawerProps {
  question: string;
  suggestion?: string;
  questionText?: string;
}

export const QuestionElement = ({ question, suggestion }: QuestionDrawerProps) => {
  const { questionText } = useThemeContext();
  return (
    <Box width='100%' mx='auto' maxWidth={{ lg: 700, xl: 1040 }} textAlign={'center'}>
      <Grid container justifyContent='center'>
        <Box clone py={2}>
          <Grid xs={10} item>
            <Box width='100%' py={2} mx='auto'>
              <Typography variant='h6' style={{ color: questionText }} className='semiBold'>
                {question}
              </Typography>
            </Box>
            <Box width='100%' mx='auto' mb={1}>
              <Typography variant='subtitle2' style={{ color: questionText }}>
                {suggestion}
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
